import { FontWeight, bold, light, normal, thin } from "@cloudinary/transformation-builder-sdk/qualifiers/fontWeight";
export { FontWeight, bold, light, normal, thin };
